import {createSlice} from "@reduxjs/toolkit"

interface template{
    template:number
}
const initialState :template= {
    template:1
}
const PrintTemplateSlice=createSlice({
    initialState,
    name:"PrintTemplateSlice",
    reducers:{
        selecTemplate:(state,action)=>{
            state.template =action.payload
        },
        // clearPaginate:(state)=>{
        //     state.template=1
        // }
    }

})

export const {selecTemplate}=PrintTemplateSlice.actions
export default PrintTemplateSlice.reducer